import { faFacebookF, faLinkedinIn, faXTwitter } from "@fortawesome/free-brands-svg-icons";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "bootstrap/js/dist/tooltip";
import ClipboardJS from "clipboard";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";
import { actions as flashesActions } from "store/flashes";

const SocialShareNav = () => {
	const dispatch = useDispatch();

	// ref hook
	const clipboardCopyButtonRef = useRef(null);

	// effect hook
	useEffect(() => {
		[...document.querySelectorAll("[data-bs-toggle='tooltip']")]?.map((ele) => Tooltip.getOrCreateInstance(ele));
		return () =>
			[...document.querySelectorAll("[data-bs-toggle='tooltip']")]?.map((ele) =>
				Tooltip.getOrCreateInstance(ele).dispose()
			);
	}, []);

	useEffect(() => {
		const clipboardCopyButtonRefCurrent = clipboardCopyButtonRef?.current;
		let clipboardCopyNoteButton;
		const message = "Copied to clipboard!";

		const onClipboardSuccessCallback = () =>
			dispatch(flashesActions.add({ type: "success", message, id: message }));

		if (!clipboardCopyNoteButton && clipboardCopyButtonRefCurrent) {
			clipboardCopyNoteButton = new ClipboardJS(clipboardCopyButtonRefCurrent, {
				text: (trigger) => trigger.getAttribute("data-clipboard-text"),
			}).on("success", onClipboardSuccessCallback);
		}

		return () => {
			if (clipboardCopyNoteButton && clipboardCopyButtonRefCurrent) clipboardCopyNoteButton.destroy();
		};
	}, [dispatch]);

	return (
		<nav className="social-share-nav" aria-label="social media share navigation">
			<ul className="list-unstyled mb-0">
				<li data-bs-toggle="tooltip" data-bs-placement="top" title="Share On Facebook">
					<FacebookShareButton
						url={window.location.href}
						className="btn btn-link text-decoration-none p-1 shadow-none fs-5 w-100"
						resetButtonStyle={false}
						aria-label="facebook link">
						<FontAwesomeIcon icon={faFacebookF} />
					</FacebookShareButton>
				</li>
				<li data-bs-toggle="tooltip" data-bs-placement="top" title="Share On Twitter">
					<TwitterShareButton
						url={window.location.href}
						className="btn btn-link text-decoration-none p-1 shadow-none fs-5 w-100"
						resetButtonStyle={false}
						aria-label="twitter link">
						<FontAwesomeIcon icon={faXTwitter} />
					</TwitterShareButton>
				</li>
				<li data-bs-toggle="tooltip" data-bs-placement="top" title="Share On Linkedin">
					<LinkedinShareButton
						url={window.location.href}
						className="btn btn-link text-decoration-none p-1 shadow-none fs-5 w-100"
						resetButtonStyle={false}
						aria-label="linkedin link">
						<FontAwesomeIcon icon={faLinkedinIn} />
					</LinkedinShareButton>
				</li>
				<li>
					<button
						className="btn btn-link text-decoration-none p-1 shadow-none fs-5 w-100"
						type="button"
						data-clipboard-text={window.location.href}
						data-bs-toggle="tooltip"
						data-bs-placement="top"
						title="Copy To Clipboard!"
						ref={clipboardCopyButtonRef}>
						<FontAwesomeIcon icon={faLink} />
					</button>
				</li>
			</ul>
		</nav>
	);
};

export default SocialShareNav;
